// Central test IDs for the DIY Trades app
export const IDS = {
  // Landing
  landingHero: 'landing-hero',
  landingCtaStart: 'landing-cta-start',
  landingCtaLogin: 'landing-cta-login',

  // Auth
  authTabLogin: 'auth-tab-login',
  authTabSignup: 'auth-tab-signup',
  authEmail: 'auth-email',
  authPassword: 'auth-password',
  authName: 'auth-name',
  authSubmit: 'auth-submit',
  authError: 'auth-error',

  // Header
  headerLogo: 'header-logo',
  headerHistory: 'header-history',
  headerNew: 'header-new',
  headerLogout: 'header-logout',
  headerUser: 'header-user',

  // Ask
  askTextarea: 'ask-textarea',
  askTradeSelect: 'ask-trade-select',
  askPhotoInput: 'ask-photo-input',
  askPhotoPreview: 'ask-photo-preview',
  askPhotoRemove: 'ask-photo-remove',
  askVoiceBtn: 'ask-voice-btn',
  askVoiceStatus: 'ask-voice-status',
  askSubmit: 'ask-submit',
  askError: 'ask-error',

  // Solution
  solutionTitle: 'solution-title',
  solutionSummary: 'solution-summary',
  solutionAdvancedBadge: 'solution-advanced-badge',
  solutionDifficulty: 'solution-difficulty',
  solutionTime: 'solution-time',
  solutionCost: 'solution-cost',
  solutionSteps: 'solution-steps',
  solutionStepItem: 'solution-step-item',
  solutionTools: 'solution-tools',
  solutionMaterials: 'solution-materials',
  solutionSafety: 'solution-safety',
  solutionCallProBtn: 'solution-call-pro-btn',
  solutionBackBtn: 'solution-back-btn',

  // Call a pro
  proZipInput: 'pro-zip-input',
  proSearchBtn: 'pro-search-btn',
  proResults: 'pro-results',
  proGoogleLink: 'pro-google-link',
  proYelpLink: 'pro-yelp-link',
  proContactCard: 'pro-contact-card',
  proContactCall: 'pro-contact-call',

  // History
  historyList: 'history-list',
  historyItem: 'history-item',
  historyEmpty: 'history-empty',

  // Sponsor Admin Dashboard
  adminNavLink: 'admin-nav-link',
  adminTotalCalls: 'admin-total-calls',
  adminCalls7d: 'admin-calls-7d',
  adminCalls30d: 'admin-calls-30d',
  adminConversion: 'admin-conversion',
  adminByPlacement: 'admin-by-placement',
  adminByTrade: 'admin-by-trade',
  adminDailyChart: 'admin-daily-chart',
  adminRecentTable: 'admin-recent-table',
  adminForbidden: 'admin-forbidden',

  // Corey Video Demo
  videoSection: 'video-section',
  videoGenerateBtn: 'generate-video-btn',
  videoPlayer: 'corey-video',
  coreyAvatar: 'corey-avatar',

  // Sponsor banner
  sponsorBanner: 'sponsor-banner',
  sponsorCall: 'sponsor-call',
};
